module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp2_9016.11437237.png";